import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import InboundIpAddresses from '../../_snippets/inbound-ip-addresses.mdx';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`The MongoDB connector can link your `}<inlineCode parentName="p">{`mongodb`}</inlineCode>{` tables to PostHog.`}</p>
    <p>{`To link MongoDB:`}</p>
    <ol>
      <li parentName="ol">{`Go to the `}<a parentName="li" {...{
          "href": "https://us.posthog.com/pipeline/sources"
        }}>{`Data pipeline page`}</a>{` and the sources tab in PostHog`}</li>
      <li parentName="ol">{`Click `}<strong parentName="li">{`New source`}</strong>{` and select MongoDB`}</li>
      <li parentName="ol">{`Enter your mongodb connection string`}</li>
      <li parentName="ol">{`Click `}<strong parentName="li">{`Link`}</strong></li>
    </ol>
    <p>{`Once the syncs are complete, you can start using MongoDB data in PostHog.`}</p>
    <blockquote>
      <p parentName="blockquote"><strong parentName="p">{`Note:`}</strong>{` MongoDB data is unstructured so the returned columns are an `}<inlineCode parentName="p">{`_id`}</inlineCode>{` field and a `}<inlineCode parentName="p">{`data`}</inlineCode>{` column that contain the entire document contents. Data fields can be selected with dot notation (e.g. `}<inlineCode parentName="p">{`data.field1`}</inlineCode>{`)`}</p>
    </blockquote>

    <InboundIpAddresses mdxType="InboundIpAddresses" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      